import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { inject } from '@app/providers/QAU.ContextProvider';
import './ViewsContainer.scss';
import './ViewsContainerMobile.scss';

import {
  UPLOAD_ART_VIEW,
  CUSTOMIZE_VIEW,
  WHITE_INK_OPTIONS_VIEW,
  ERROR_MODE_VIEW,
  APPLY_CODES_VIEW,
  LOGIN_SIGNUP_VIEW,
} from '@app/constants';
import { changeRoute } from '@app/actions/navigationActions';
import { setFooterConfig } from '@app/actions/footerActions';
import router from '@app/router';
import { isMobileMode, isMultiUpload } from '@app/utils/utils';
import { getDeviceOrientation, registerOrientationListener, isLandscapeOrientation } from '@app/utils/device';

import UploadView from './upload/UploadView';
import MultiUploadView from './upload/MultiUploadView';
import CustomizeView from './customize/CustomizeView';
import WhiteInkOptionsView from './white-ink-options/WhiteInkOptionsView';
import ErrorModeView from './error-mode/ErrorModeView';
import ApplyCodesView from './apply-codes/ApplyCodesView';
import LoginSignup from './apply-codes/login-signup/LoginSignup';
import UnsupportedOrientation from './UnsupportedOrientation';

const ViewsContainer = ({ view, isMobileView, changeRoute, setFooterConfig, multiUpload }) => {
  const [deviceOrientation, setDeviceOrientation] = useState(getDeviceOrientation());

  useEffect(() => {
    router.subscribe('onRoute', ({ matrix, view }) => changeRoute(view, matrix));
    return () => router.unsubscribe('onRoute');
  }, [changeRoute]);

  useEffect(() => {
    isMobileView && registerOrientationListener(deviceOrientation => setDeviceOrientation(deviceOrientation));
  }, [isMobileView]);

  useEffect(() => {
    isMobileView &&
      setFooterConfig({
        customClassName: 'mobile',
      });
  }, [setFooterConfig, isMobileView]);

  const viewComponents = {
    [UPLOAD_ART_VIEW]: multiUpload ? <MultiUploadView /> : <UploadView />,
    [CUSTOMIZE_VIEW]: <CustomizeView />,
    [WHITE_INK_OPTIONS_VIEW]: <WhiteInkOptionsView />,
    [ERROR_MODE_VIEW]: <ErrorModeView />,
    [APPLY_CODES_VIEW]: <ApplyCodesView />,
    [LOGIN_SIGNUP_VIEW]: <LoginSignup />,
  };

  return (
    <>
      <div id="qau-views-container" className={classnames({ mobile: isMobileView })}>
        {viewComponents[view]}
      </div>
      <UnsupportedOrientation visible={isMobileView && isLandscapeOrientation(deviceOrientation)} />
    </>
  );
};

ViewsContainer.propTypes = {
  multiUpload: PropTypes.bool.isRequired,
  isMobileView: PropTypes.bool.isRequired,
  view: PropTypes.string.isRequired,
  changeRoute: PropTypes.func.isRequired,
  setFooterConfig: PropTypes.func.isRequired,
};

const mapStateToProps = ({ matrix: { view, ctx } }, { flowConfig = {} }) => {
  return {
    view,
    isMobileView: isMobileMode(ctx),
    multiUpload: isMultiUpload(flowConfig),
  };
};
const mapDispatchToProps = { changeRoute, setFooterConfig };

export default inject('flowConfig')(connect(mapStateToProps, mapDispatchToProps)(ViewsContainer));
